var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'antd/lib/select';
import AutoComplete from './AutoComplete';
import Color from './Color';
import InputGroup from './InputGroup';
import { getParentNode } from '../../utils';
var Option = Select.Option;
var BoxModel = /** @class */ (function (_super) {
    __extends(BoxModel, _super);
    function BoxModel(props) {
        var _this = _super.call(this, props) || this;
        _this.getInput = function (isRadius) {
            var value = _this.props.value;
            return ((isRadius ? _this.radioKeys : _this.props.keys).map(function (key) {
                var v = (value && value[key]) ||
                    (typeof value === 'string' ? value : null);
                if (key === 'center') {
                    var values_1 = Object.keys(value).map(function (c) { return value[c]; });
                    var equal = values_1.every(function (c) { return c === values_1[0]; });
                    v = equal ? values_1[0] : v;
                }
                return (React.createElement(AutoComplete, { key: key, value: v, className: key, placeholder: key, disabled: _this.props.disabled }));
            }));
        };
        _this.getColor = function () {
            var value = _this.props.value;
            return (_this.props.keys.map(function (key) {
                var v = (value && value[key]) ||
                    (typeof value === 'string' ? value : null);
                return (React.createElement(Color, { key: key, type: "cut", className: key, color: v }));
            }));
        };
        _this.getSelect = function () {
            var select = ['none', 'solid', 'dashed', 'dotted', 'double'];
            var value = _this.props.value;
            return (_this.props.keys.map(function (key) {
                var v = (value && value[key]) ||
                    (typeof value === 'string' ? value : select[0]);
                return (React.createElement(Select, { className: key, size: "small", key: key, value: v, getPopupContainer: function (node) { return getParentNode(node, 'editor-list'); }, dropdownMatchSelectWidth: false, dropdownClassName: "editor-list-dropdown" }, select.map(function (cKey) { return (React.createElement(Option, { value: cKey, key: cKey }, cKey)); })));
            }));
        };
        _this.getChildrenToBox = function () {
            switch (_this.props.name) {
                case 'color':
                    return _this.getColor();
                case 'style':
                    return _this.getSelect();
                default:
                    return _this.getInput(_this.props.name === 'radius');
            }
        };
        _this.radioKeys = ['top-left', 'top-right', 'bottom-right', 'bottom-left', 'center'];
        return _this;
    }
    BoxModel.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: "box-model-wrapper" },
            React.createElement(InputGroup, { className: "box-model", onChange: function (v, isDrag) {
                    _this.props.onChange(v, isDrag);
                } }, this.getChildrenToBox())));
    };
    BoxModel.propTypes = {
        value: PropTypes.any,
        onChange: PropTypes.func,
        keys: PropTypes.array,
        name: PropTypes.string,
        disabled: PropTypes.bool,
    };
    BoxModel.defaultProps = {
        keys: ['top', 'right', 'bottom', 'left', 'center'],
        onChange: function () { },
    };
    return BoxModel;
}(Component));
export default BoxModel;
